import { type Component } from 'solid-js';
import Exposures from '~/features/exposure';

// What you actually own, once the funds are resolved to what is inside them.
// Full width: the point of the page is the "held through" column, which needs
// room to list every fund reaching the same company, sector or region.
const ExposurePage: Component = () => (
    <div class='flex-1 min-w-0'>
        <Exposures />
    </div>
);

export default ExposurePage;
